import React, {  useState } from 'react';
import styled from 'styled-components';
import BarGraph from '../../../Common/BarGraph/BarGraph';
import GraphHOC from '../../../Common/GraphHOC/GraphHOC';
import RatingDonutChart from '../../../Common/RatingDonutChart/DonutChart';
import DonutChart from '../../../Common/SentimentCharts/SentimentCharts';
import FunnelGraph from '../../../Common/FunnelGraph/FunnelGraph';
import VerticalBarGraph from '../../../Common/BarGraph/VarticalBargraph';
import { useParsedEndDate, useParsedStartDate } from '../../../utils/ParseDate';
import TitleWithInfo from '../../../Common/TitleWithInfo/TitleWithInfo';
import SentimentTopicSection from './SentimentTopicSection';
import TopSentimentCard from './TopSentimentCard';
import SentimentPostCount from './SentimentPostCount';

const Wrapper = styled.div`
  padding: 30px;
  margin-bottom: 50px;

  & .title {
    /* color: #636363; */
    font-family: Montserrat;
    font-size: 15px;
    font-weight: 500;
  }
`;

const TopRepostWrapper = styled.div`
  margin-top: 30px;
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 10px 20px;
  align-items: center;
`;


const TopPostWrapper = styled.div`
  & > div {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 1em;
    border-radius: 15px;
    padding: 20px;

    .reviewText {
      word-break: break-word;
      flex: 1;
      border-right: 1px solid #d9d9d9;
      padding: 0 10px;
      max-width: 80%;
      font-family: 'Inter';
    }
    .reviewCount {
      width: 10%;
      text-align: center;

      font-family: 'Inter';
      .peopleLiked {
        font-size: 10px;
      }
    }
  }

  .positiveReview {
    background: rgba(92, 227, 144, 0.2);
  }

  .negativeReview {
    background: rgba(249, 98, 89, 0.18);
  }

  .neutralReview {
    background: rgba(254, 222, 141, 0.37);
  }
`;

const SentimentDrilldownWrapper = styled.div`
  border-radius: 15px;
  border: 1px solid #d9d9d9;
  padding: 10px;
  padding-top: 0px;
  align-items: center;
`;

const Footer = styled.div`
  color: #2a2929;
  font-family: Open Sans;
  font-size: 11px;
  font-weight: 400;
  text-align: right;
  margin-top: 30px;
  font-family: 'Inter';
`;



const Sentiments = ({
  sentiments_tab = {},
  startDate = '',
  endDate = '',
  filterOption,
  filteredData,
  filteredStartDate,
  filteredEndDate,
  view,
  resetFlag,
  channel,
  hideDropdown,
  is_news = false,
  formatValue = 'dd-yyyy-MM',
  handleTabClick,
  job_id,
}) => {
  const [topTopicCount, setTopTopicCount] = useState({
    positive: '1 Topic',
    negative: '1 Topic',
    neutral: '1 Topic',
  });

  const [openDropdown, setOpenDropdown] = useState(null); // Manage open state for multiple dropdowns

  const options = ['Bar Graph', 'Pie Chart', 'Donut Chart', 'Funnel Chart'];

  const percentageValue =
    resetFlag === true && filteredData
      ? filteredData?.sentiment_drilldown
      : sentiments_tab?.sentiment_drilldown;

  const sentimentsData = [
    {
      name: 'Positive',
      value: parseFloat(percentageValue?.positive_sentiment),
      // fill: 'rgba(3, 198, 82, 0.8)',
      fill: '#36D174',
    },
    {
      name: 'Negative',
      value: parseFloat(percentageValue?.negative_sentiment),
      // fill: 'rgba(238, 19, 7,  0.8)',
      fill: '#F14239',
    },
    {
      name: 'Neutral',
      value: parseFloat(percentageValue?.neutral_sentiment),
      // fill: 'rgba(255, 225, 69, 0.8)',
      fill: '#FCDE94',
    },
  ];

  const sentimentsRenderScreen = {
    'Bar Graph':
      view === 'vertical' ? (
        <VerticalBarGraph
          data={sentimentsData}
          type={'%'}
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
          drillThroughType={'sentiment'}
          width='105px'
        />
      ) : (
        <BarGraph
          job_id={job_id}
          handleTabClick={(data) => handleTabClick(data)}
          drillThroughType={'sentiment'}
          data={sentimentsData}
          maxWidth={'60%'}
          type={'%'}
        />
      ),
    'Pie Chart': (
      <RatingDonutChart
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'sentiment'}
        data={sentimentsData}
        width={500}
        type='percentage'
      />
    ),
    'Donut Chart': (
      <DonutChart
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'sentiment'}
        data={sentimentsData}
        sentiment={true}
        type='percentage'
      />
    ),
    'Funnel Chart': (
      <FunnelGraph
        job_id={job_id}
        handleTabClick={(data) => handleTabClick(data)}
        drillThroughType={'sentiment'}
        data={sentimentsData}
        maxWidth={'50%'}
        type={'%'}
      />
    ),
  };

  const handleTopTopicCountChange = (topic, topicType) => {
    if (topicType === 'positive') {
      setTopTopicCount({ ...topTopicCount, positive: topic });
    } else if (topicType === 'neutral') {
      setTopTopicCount({ ...topTopicCount, neutral: topic });
    } else if (topicType === 'negative') {
      setTopTopicCount({ ...topTopicCount, negative: topic });
    }
  };

  const renderTopics = (topicStrings, type) => {
    const topicData = Object.keys(topicStrings);
    // if (topicData.length === 0) return null;
    if (!topicStrings || Object.keys(topicStrings).length === 0) return null;

    const topicCount = parseInt(topTopicCount[type]);
    const topicKeys = topicData.slice(0, topicCount);

    // const topicKeys = topicData.filter(
    //   (key, index) => index < topTopicCount[type].split(' ')[1]
    // );
    return topicKeys.map((key, index) => (
      <div key={key}>{`Topic #${index + 1}  ${topicStrings[key]}`}</div>
    ));
  };

  const totalTopicsColumn = (topicStrings) => {
    const topicData = Object.keys(topicStrings);
    if (topicData.length === 0) return ['No Topic'];

    // const columns = [];
    // topicData.forEach((_, index) => {
    //   columns.push('Topic ' + (index + 1));
    // });
    const columns = topicData.map(
      (_, index) => `${index + 1} Topic${index + 1 > 1 ? 's' : ''}`
    );

    return columns;
  };

  const startDateParsed = useParsedStartDate(
    resetFlag,
    filteredStartDate,
    startDate,
    formatValue
  );
  const endDateParsed = useParsedEndDate(
    resetFlag,
    filteredEndDate,
    endDate,
    formatValue
  );

  if (Object.keys(sentiments_tab).length === 0) {
    return (
      <h2
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '30px',
        }}
      >
      Insufficient Data
      </h2>
    );
  }
  return (
    <Wrapper>
      <SentimentDrilldownWrapper>
        <GraphHOC
          title={'Sentiment Drilldown'}
          options={options}
          renderScreen={sentimentsRenderScreen}
          graphWidth={'100%'}
          margin={'20px 0px 20px 50px'}
          option={filterOption}
          hideDropdown={hideDropdown}
          startDate={startDateParsed}
          endDate={endDateParsed}
          formatValue={formatValue}
          showDate={false}
          infoText={`Analyzes user ${channel === 'instagram' || channel == 'facebook'
            ? 'comments'
            : 'posts'
            } by sentiment—positive, negative, or neutral—and highlights key topics associated with each category, requiring a minimum of 5 data points per sentiment for inclusion.`}
        />
        <SentimentTopicSection
          label='Positive Sentiments the posts were majorly related to:'
          className='positiveTopic'
          dropdownId='dropdown1'
          topicData={sentiments_tab?.topic_analysis?.positive_topics}
          sentimentKey='positive'
          handleChange={handleTopTopicCountChange}
          renderTopics={renderTopics}
          openDropdown={openDropdown}
          setOpenDropdown={setOpenDropdown}
          totalTopicsColumn={totalTopicsColumn}
        />

        <SentimentTopicSection
          label='Neutral Sentiments the posts were majorly related to:'
          className='neutralTopic'
          dropdownId='dropdown2'
          topicData={sentiments_tab?.topic_analysis?.neutral_topics}
          sentimentKey='neutral'
          handleChange={handleTopTopicCountChange}
          renderTopics={renderTopics}
          openDropdown={openDropdown}
          setOpenDropdown={setOpenDropdown}
          totalTopicsColumn={totalTopicsColumn}
        />

        <SentimentTopicSection
          label='Negative Sentiments the posts were majorly related to:'
          className='negativeTopic'
          dropdownId='dropdown3'
          topicData={sentiments_tab?.topic_analysis?.negative_topics}
          sentimentKey='negative'
          handleChange={handleTopTopicCountChange}
          renderTopics={renderTopics}
          openDropdown={openDropdown}
          setOpenDropdown={setOpenDropdown}
          totalTopicsColumn={totalTopicsColumn}
        />
        <Footer>
          {` This data is observed from ${startDateParsed} to ${endDateParsed}`}
        </Footer>
      </SentimentDrilldownWrapper>

      {is_news == true ? (
        <></>
      ) : (
        <TopRepostWrapper>
          <p className='title'>
            <TitleWithInfo
              // title={(channel === 'instagram' || channel == 'facebook') ? 'Top Posts' : 'Top Reposts'}
              //  channel == 'facebook' ? 'Top Posts'
              title={
                channel === 'instagram' ||
                  channel == 'facebook' ||
                  channel == 'youtube'
                  ? 'Top Liked Comments'
                  : 'Top Reposts'
              }
              // infoText={`This represents the post with the highest engagement in terms of ${(channel === 'instagram' || channel == 'facebook') ? 'likes' : 'Reposts'}, categorized by sentiment (positive, negative, or neutral).`} ${(channel === 'instagram') ? 'Comments' : (channel == 'facebook') ? 'likes' : 'Reposts'}, categorized by sentiment (positive, negative, or neutral).
              infoText={
                channel === 'instagram' ||
                  channel == 'facebook' ||
                  channel == 'youtube'
                  ? `Track the most liked comments based on sentiment—positive, negative, and neutral—providing a snapshot of key audience feedback.`
                  : `Track the most liked posts based on sentiment—positive, negative, and neutral—providing a snapshot of key audience feedback.`
              }
            />
          </p>

          {channel == 'youtube' ? (
            <></>
          ) : (
            <SentimentPostCount
              channel={channel}
              filteredData={filteredData}
              sentiments_tab={sentiments_tab}
            />
          )}
          <TopPostWrapper>
            <TopSentimentCard
              sentiment="positive"
              channel={channel}
              filteredData={filteredData}
              sentiments_tab={sentiments_tab}
            />
            <TopSentimentCard
              sentiment="negative"
              channel={channel}
              filteredData={filteredData}
              sentiments_tab={sentiments_tab}
            />
            <TopSentimentCard
              sentiment="neutral"
              channel={channel}
              filteredData={filteredData}
              sentiments_tab={sentiments_tab}
            />
          </TopPostWrapper>
          <Footer>
            {` This data is observed from ${startDateParsed} to ${endDateParsed}`}
          </Footer>
        </TopRepostWrapper>
      )}
    </Wrapper>
  );
};

export default Sentiments;
